module.exports = __webpack_public_path__ + "static/img/wuliu-jianbianffe_ffdf_px.e41500fc.png";